import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetS3RagRegisteredPathUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (s3_key: string, customer: any): Promise<any> => {
        return await this._aiRepository.getAIS3RagRegisteredPath(s3_key, customer);
    }
}

export const GetS3RagRegisteredPathUseCaseName = "GetS3RagRegisteredPathUseCaseName";